export const useCheckDate = (date: string) => {
	if (date === null || date === '') {
		return 'n/a';
	}
	return date;
};
